import { Injectable } from "@angular/core";


@Injectable({
    providedIn:'root'
})

export class ToggleStateService{
    private _sharedValue: boolean = false;

   get sharedValue(): boolean{
    return this._sharedValue;
   }

   set sharedValue(value: boolean){
    this._sharedValue = value;
   }

}